// Access-code validation for the eBook and Audiobook VIP gates.
//
// Mirrors CodeAccessController::validateCode() (POST /api/access/validate-code).
// The reader pages themselves (book.blade.php / AudioBook.blade.php) are not
// yet ported to React (Phases 2/3 of the Blade -> React migration), so on
// success we hand off to the existing server-rendered reader with a full
// navigation rather than an in-app route.

import { API_URL, apiFetch } from './apiClient';

// API_URL is e.g. "http://127.0.0.1:8000/api" - the reader pages live one
// level up, at the Laravel app root.
const APP_URL = API_URL.replace(/\/api\/?$/, '');

export const ACCESS_TYPES = {
  EBOOK: 'EBOOK',
  AUDIOBOOK: 'AUDIOBOOK',
};

/**
 * These two images only exist in Laravel's public/images (they were never
 * copied into this React app's public/images), so point at the Laravel
 * app directly rather than a path that would 404 here. Once someone
 * copies AudioBookLogo.png / 1.png into frontend/public/images, this can
 * switch to a local `/images/...` path instead.
 */
export function laravelAsset(path) {
  return `${APP_URL}/${path.replace(/^\//, '')}`;
}

/**
 * @param {'EBOOK'|'AUDIOBOOK'} type
 * @param {string} code
 * @returns {Promise<{ valid: boolean, message?: string }>}
 */
export async function validateAccessCode(type, code) {
  const response = await apiFetch('access/validate-code', {
    method: 'POST',
    body: JSON.stringify({ type, code }),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    return { valid: false, message: data.message || 'Code not found!' };
  }

  return { valid: true };
}

/**
 * Full-page navigation to the existing (still server-rendered) reader.
 * Kept as a single named export so the redirect target only needs to
 * change in one place once Phases 2/3 replace it with an in-app route.
 */
export function goToReader(type, code) {
  const path = type === ACCESS_TYPES.EBOOK ? 'accesses/book' : 'accesses/AudioBook';
  window.location.href = `${APP_URL}/${path}?query=${encodeURIComponent(code)}`;
}
